export const CUSTOMER_EXTERNAL_REFERENCE_KEY = {
    PHONE: "phone",
    SALTO_CUSTOMER_ID: "saltoCustomerId",
    SALTO_CUSTOMER_FLORIDA_ID: "saltoCustomerFloridaId",
    DDS_ID: "ddsCustomerId",
    KINDLE_EMAIL: "kindleEmail",
    DATA_FACTORY_ID: "dataFactoryId",
};
export const CUSTOMER_METADATA = {
    CUSTOMER_STATUS: "customerStatus",
    CUSTOMER_STATUS_REASON: "customerStatusReason",
    VERIFIED_EMAIL: "verifiedEmail",
    SALTO_DEBT_STATUS: "saltoDebtStatus",
    ORGANIZATION_NUMBER: "organizationNumber",
    ORGANIZATION_TYPE: "organizationType",
    SCHOOL_TYPE: "schoolType",
    SCHOOL_CUSTOMER_STATUS: "schoolCustomerStatus",
};
export const CUSTOMER_ADDRESS_METADATA = {
    USE_EHF: "useEhf",
    INVOICE_ORGANIZATION_NUMBER: "invoiceOrganizationNumber",
    INVOICE_REFERENCE: "invoiceReference",
};
export var CustomerType;
(function (CustomerType) {
    CustomerType["INDIVIDUAL"] = "individual";
    CustomerType["ORGANIZATION"] = "organization";
})(CustomerType || (CustomerType = {}));
export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus["SUSPENDED"] = "suspended";
})(CustomerStatus || (CustomerStatus = {}));
export var CustomerStatusReason;
(function (CustomerStatusReason) {
    CustomerStatusReason["DEBT_COLLECTION"] = "debtCollection";
    CustomerStatusReason["UNWANTED"] = "unwanted";
    CustomerStatusReason["DECEASED"] = "deceased";
})(CustomerStatusReason || (CustomerStatusReason = {}));
export const statusReasonLabels = {
    [CustomerStatusReason.UNWANTED]: "Uønsket",
    [CustomerStatusReason.DECEASED]: "Død",
    [CustomerStatusReason.DEBT_COLLECTION]: "Aktiv inkasso",
};
export const ORGANIZATION_INVITATION_METADATA = {
    INVITE_AUDIENCE: "organization-invite",
    INVITE_ISSUER: "netthandel",
};
export const SCHOOL_ORGANIZATION_STATUS = {
    APPROVED: "approved",
    PENDING_APPROVAL: "pending_approval",
    DENIED: "denied",
};
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["SCHOOL"] = "school";
    OrganizationType["COMPANY"] = "company";
    OrganizationType["DEALER"] = "dealer";
    OrganizationType["GROUPING"] = "grouping";
    OrganizationType["UNKNOWN"] = "unknown";
})(OrganizationType || (OrganizationType = {}));
export var SchoolType;
(function (SchoolType) {
    SchoolType["PRIMARY_SCHOOL"] = "primarySchool";
    SchoolType["LOWER_SECONDARY_SCHOOL"] = "lowerSecondarySchool";
    SchoolType["COMBINED_SCHOOL"] = "combinedSchool";
    SchoolType["HIGH_SCHOOL"] = "highSchool";
    SchoolType["ADULT_EDUCATION"] = "adultEducation";
    SchoolType["KINDERGARTEN"] = "kindergarten";
    SchoolType["HIGHER_EDUCATION"] = "higherEducation";
})(SchoolType || (SchoolType = {}));
export const SCHOOL_TYPE_GROUPING_PARENTS = {
    [SchoolType.PRIMARY_SCHOOL]: ["alle-barneskoler"],
    [SchoolType.LOWER_SECONDARY_SCHOOL]: ["alle-ungdomsskoler"],
    [SchoolType.COMBINED_SCHOOL]: ["alle-barneskoler", "alle-ungdomsskoler"],
    [SchoolType.HIGH_SCHOOL]: ["alle-videregaende-skoler"],
    [SchoolType.ADULT_EDUCATION]: ["alle-voksenopplaeringer"],
    [SchoolType.KINDERGARTEN]: [],
    [SchoolType.HIGHER_EDUCATION]: [],
};
export const ORGANIZATION_CUSTOMER_GROUP = {
    ORGANIZATIONS: "organisasjoner",
    PRIVATE_SCHOOLS: "private-skolekunder",
};
